export default __webpack_public_path__ + "static/media/bastion-intro.da0169f9.mp3";